import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn} from "../../../../components/table-list-input/table-list-input.component";
import {IKeyboardPage} from "../../../../interfaces";
import {
  DialogGetAssetComponent,
  IDialogGetAsset
} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../mime-constants";
import * as _ from "lodash";
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-scene-block-keyboard',
  templateUrl: './block-keyboard.component.html',
  styleUrls: ['./block-keyboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockKeyboardComponent extends BlockBaseComponent {
  buttons: IButtonBar[] = [];
  tableColumns: Array<ITableListColumn> = [];

  constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog, public cd: ChangeDetectorRef) {
    super(storeSelector, dialog);
    this.tableColumns = [{
      inputType: 'edit',
      name: 'name',
      maxStringSize: '16'
    }, {
      inputType: 'text',
      name: 'scene',
      maxStringSize: '10'
    }];
    this.buttons = [
      {
        callBack: v => (v),
        icon: 'add',
        name: 'add',
        disableByList: false,
        disabled: false,
        tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
      },
      {
        callBack: v => (v),
        icon: 'remove',
        name: 'remove',
        confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
        disableByList: true,
        disabled: false,
        tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
      },
      {
        callBack: v => (v),
        icon: 'arrow_left',
        name: 'previous',
        disableByList: true,
        disabled: false,
        tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
      },
      {
        callBack: v => (v),
        icon: 'arrow_right',
        name: 'next',
        disableByList: true,
        disabled: false,
        tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
      }
    ];
  }

  override submit(formValues) {
    if (formValues.Keyboard?.currentAction && formValues.Keyboard.currentAction === 'added') {
      this.openAssociateDialog();
    }
    super.submit(formValues);
  }

  openAssociateDialog() {
    const data: IDialogGetAsset = {mode: "SCENE:PLAYER", mimeType: SceneMimeTypes.Player};
    const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
      width: '70%',
      panelClass: 'custom-dlg-container',
      data
    });
    this.cod(
      dialogRefVal.afterClosed()
        .subscribe((dialogGetAsset: IDialogGetAsset) => {
          if (!dialogGetAsset?.selectedType) return;
          this.addTableItem(dialogGetAsset);
        })
    );
  }

  addTableItem(dialogGetAsset: IDialogGetAsset) {
    const pager: IKeyboardPage = {
      $: {name: 'soft key'},
      Player: [{$: {src: dialogGetAsset.selected}}]
    };
    const pages = this.sceneItem.Data[0].Keyboards[0].Keyboard && _.isArray(this.sceneItem.Data[0].Keyboards[0].Keyboard) ? _.cloneDeep(this.sceneItem.Data[0].Keyboards[0].Keyboard) : [];
    pages.push(pager);
    this.dispatchSceneItemChanges({
      sceneId: this.sceneId,
      sceneItemId: this.sceneItem.$.id,
      values: [{
        key: 'Keyboard',
        value: pages,
        storePath: 'Data[0].Keyboards[0]'
      }]
    });
    super.initApplyStoreToDynamic(true);
  }

  override componentInit() {
    super.componentInit();
  }

  override componentStoreUpdates() {
    super.componentStoreUpdates();
    this.cd.detectChanges();
  }

  override initRegisterDynamic() {
    this.uiConfigInit = [
      {
        type: "input",
        label: '',
        inputType: 'tablelist',
        tableColumns: this.tableColumns,
        cloneVals: true,
        multiSelect: false,
        rememberSelection: true,
        allowFilter: true,
        buttonBarClassName: 'keyboardButtonBar',
        buttons: this.buttons,
        inputEditFormat: {name: 'name', src: 'name'},
        inputEditRenamePath: [{path: '$.name', key: 'name'}, {path: '$.src', key: 'src'}],
        callBackValue: (item, direction) => {
          switch (direction) {
            case 'IN': {
              this.storeSelector.getScene(item.Player[0].$.src)
                .pipe(take(1))
                .subscribe((scene) => {
                  item.$ = {name: item.$.name, scene: scene.Player.$.label, src: item.Player[0].$.src};
                });
              return item;
            }
            case 'OUT': {
              return {
                $: {name: item.$.name},
                Player: [{$: {src: item.$.src}}]
              };
            }
          }
        },
        name: "Keyboard",
        storePath: 'Data[0].Keyboards[0].Keyboard',
        expandableEditor: true,
      }
      // ,{
      //     type: "checkbox",
      //     value: '1',
      //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
      //     name: "gpu",
      //     storePath: '$.gpu'
      // }
    ];
  }
}
